import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["busy", "fileInput"]

  begin(event) {
    const input = this.hasFileInputTarget
      ? this.fileInputTarget
      : this.element.querySelector('input[type="file"]')

    if (!input?.files?.length) return

    if (this.hasBusyTarget) {
      this.busyTarget.hidden = false
    }

    const submit =
      event.submitter || this.element.querySelector('[type="submit"]')
    if (submit) submit.disabled = true
  }
}
